var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.356,
    height: 16.364,
    viewBox: "0 0 9.356 16.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-forward",
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M17.782,14.375,11.59,8.188a1.164,1.164,0,0,1,0-1.652,1.179,1.179,0,0,1,1.656,0l7.016,7.011A1.167,1.167,0,0,1,20.3,15.16l-7.045,7.06a1.17,1.17,0,0,1-1.656-1.652Z",
    transform: "translate(-11.246 -6.196)",
    fill: "#de4f2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleShow);
export default __webpack_public_path__ + "static/media/toggle-show.53960ae181d0c44a49b7defd7f016090.svg";
export { ForwardRef as ReactComponent };